export default __webpack_public_path__ + "static/Chard-Farm-Winery-248c612c3db6eba02cea1b826d8bda37.jpg";